import BaseNoteAreaModel from '@src/slide/application/service/note-area-component/core/base/base-note-area-model';
import { IPcNoteAreaProps, IPcNoteAreaState } from '@src/slide/application/service/note-area-component/core/pc/type';
import { NOTE_DEFAULT_HEIGHT } from '@editor/src/js/constants';

export default class PcNoteAreaModel extends BaseNoteAreaModel<IPcNoteAreaProps> implements IPcNoteAreaState {
    public initModel(props?: IPcNoteAreaProps, initObj?: Partial<this>) {
        super.initModel(props, initObj);
        this.noteAreaHeight = NOTE_DEFAULT_HEIGHT;
    }
}
